module.exports = __webpack_public_path__ + "static/media/autoCorrect.a7684e91.svg";